import { render, staticRenderFns } from "./ProjectGroups.vue?vue&type=template&id=035b0903&"
import script from "./ProjectGroups.vue?vue&type=script&lang=ts&"
export * from "./ProjectGroups.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports